import { Backdrop, Box, Typography } from '@mui/material';

export type AuthStatusHandlerProps = {
    IconComp: JSX.Element;
    message: string;
};

const AuthStatusHandler = ({ IconComp, message }: AuthStatusHandlerProps) => {
    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'transparent' }}
            open>
            <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                {IconComp}
                <Typography variant="h1">{message}</Typography>
            </Box>
        </Backdrop>
    );
};

export enum AuthStatus {
    NoToken,
    NoTokenYet,
    Fail,
    Success
}

export default AuthStatusHandler;
